import React from "react";
import { Snackbar, SnackbarContent } from "@material-ui/core";
import { observer } from "mobx-react";
import SaveResetButtons from "./SaveResetButtons";
import styled from "styled-components";

function SaveResetButtonsSnackBar({ open, isSubSheetView }) {
  const resetButtonSnackbarStyles =
  isSubSheetView == true
    ? { width: "160px", overflowX: "hidden", borderRadius: "5px" }
    : {};
  return (
    <StyledSnackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={open}
      style={resetButtonSnackbarStyles}
    >
      <StyledSnackbarContent message={<SaveResetButtons open={open} />} />
    </StyledSnackbar>
  );
}

const StyledSnackbarContent = styled(SnackbarContent)`
  background-color: rgb(49 49 49 / 0.85);
`;

const StyledSnackbar = styled(Snackbar)`
  z-index: 10 !important;
`;
export default observer(SaveResetButtonsSnackBar);
